<div class="back-button-icon-container">
  <sbnb-back-button-icon [disableRedirect]="true" (click)="backIconClicked.emit()"></sbnb-back-button-icon>
</div>

<div class="flex flex-col h-full">
  <section class="w-full max-w-[480px] flex-1 mx-auto mt-6 md:mt-16 px-4 md:px-0">
    <ng-content select="content"></ng-content>
  </section>

  @if (hasFooterContent) {
    <footer class="sticky bottom-0">
      <div class="top-gradient"></div>
      <div class="border-t border-gray-200 bg-white py-4">
        <div #projectedFooterContainer class="max-w-[480px] px-4 md:px-0 mx-auto">
          <ng-content select="footer"></ng-content>
        </div>
      </div>
    </footer>
  }
</div>
